"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBackdrop = ModalBackdrop;

var _layout = require("react-components/layout");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["isClickable", "isVisible", "onRequestClose"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `Backdrop` styled component.
 */
var Backdrop = (0, _styledComponents["default"])(_layout.Fill).withConfig({
  displayName: "modal-backdrop__Backdrop",
  componentId: "sc-6btnjh-0"
})(["background-color:", ";opacity:0;pointer-events:none;position:fixed;transition:opacity ", ";z-index:", ";", ";", ""], _styles.color.transparentize('secondary', 0.6), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.theme)('zIndex.modal.backdrop'), (0, _styledTools.ifProp)('isClickable', (0, _styledComponents.css)(["cursor:pointer;"])), (0, _styledTools.ifProp)('isVisible', (0, _styledComponents.css)(["opacity:1;pointer-events:all;"])));
/**
 * Export `ModalBackdrop` component.
 */

function ModalBackdrop(props) {
  var _props$isClickable = props.isClickable,
      isClickable = _props$isClickable === void 0 ? true : _props$isClickable,
      isVisible = props.isVisible,
      onRequestClose = props.onRequestClose,
      rest = _objectWithoutProperties(props, _excluded);

  (0, _react.useEffect)(function () {
    function handleEscKey(event) {
      if (event.which === 27) {
        onRequestClose(event);
      }
    }

    if (isClickable && isVisible) {
      document.addEventListener('keydown', handleEscKey, false);
      return function () {
        document.removeEventListener('keydown', handleEscKey, false);
      };
    }
  }, [isClickable, isVisible, onRequestClose]);
  var handleClick = (0, _react.useCallback)(function (event) {
    if (!isClickable) {
      return;
    }

    onRequestClose(event);
  }, [isClickable, onRequestClose]);
  return /*#__PURE__*/_react["default"].createElement(Backdrop, _extends({}, rest, {
    isClickable: isClickable,
    isVisible: isVisible,
    onClick: handleClick
  }));
}